import {useCallback} from "react";
import {View} from "@unibuddy/patron";
import useRelativeRouter from "ubcommunity-shared/src/Navigation/useRelativeRouter/useRelativeRouter";
import {usePageTitle} from "ubcommunity-shared/src/Hooks/usePageTitle";
import {PageTitles, Routes} from "ubcommunity-shared/src/constants";
import {UniversalInbox} from "ubcommunity-shared/src/UniversalInbox/UniversalInbox";
import {UniversalInboxHeader} from "ubcommunity-shared/src/UniversalInbox/UniversalInboxHeader";
import {useIsAmboExperience} from "ubcommunity-shared/src/AmboInbox/useIsAmboExperience";
import {AmboInbox} from "ubcommunity-shared/src/AmboInbox/AmboInbox";

export function InboxLayout() {
    const {push} = useRelativeRouter();
    const {isAmboExperience} = useIsAmboExperience();

    usePageTitle(PageTitles.INBOX);

    const handleSelectChatGroup = useCallback(
        ({id}: {id: string}) => {
            push(`${Routes.CHAT}/${id}`);
        },
        [push],
    );

    if (isAmboExperience) {
        return <AmboInbox onSelect={handleSelectChatGroup} />;
    }

    return (
        <View flex="1">
            <UniversalInboxHeader />
            <UniversalInbox onSelect={handleSelectChatGroup} />
        </View>
    );
}
